import React from "react";
import { Box, Typography } from "@mui/material";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";

export function EmptyState({ message }) {
  return (
    <Box
      sx={{
        py: 4,
        textAlign: "center",
        border: "1px dashed #D1D5DB",
        borderRadius: 2,
        bgcolor: "#FAFBFC",
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ maxWidth: 380, mx: "auto", lineHeight: 1.65 }}
      >
        {message}
      </Typography>
    </Box>
  );
}

export function NoScenariosPlaceholder() {
  return (
    <Box
      sx={{
        py: 8,
        textAlign: "center",
        border: "2px dashed #E8ECF0",
        borderRadius: 2,
        bgcolor: "#FAFBFC",
        mt: 2,
      }}
    >
      <AssessmentOutlinedIcon sx={{ fontSize: 48, color: "#D1D5DB", mb: 2 }} />
      <Typography variant="h6" fontWeight={700} color="text.secondary" mb={0.75}>
        No historical data yet
      </Typography>
      <Typography
        variant="body2"
        color="text.disabled"
        sx={{ maxWidth: 360, mx: "auto", lineHeight: 1.65 }}
      >
        Save at least one scenario in the Simulator tab to start building your
        performance history.
      </Typography>
    </Box>
  );
}

export function NoMatchingFiltersPlaceholder() {
  return (
    <Box
      sx={{
        py: 6,
        textAlign: "center",
        border: "2px dashed #E8ECF0",
        borderRadius: 2,
        bgcolor: "#FAFBFC",
        mt: 2,
      }}
    >
      <Typography
        variant="subtitle1"
        fontWeight={700}
        color="text.secondary"
        mb={0.75}
      >
        No scenarios match these filters
      </Typography>
      <Typography
        variant="body2"
        color="text.disabled"
        sx={{ maxWidth: 400, mx: "auto", lineHeight: 1.65 }}
      >
        Try choosing a different brand or reset filters to see performance history
        again.
      </Typography>
    </Box>
  );
}
